import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { Box, Modal, useModalContext, Button } from '@app-velocity/ui';
import { SoftwareLicense } from '@app-velocity/libs/documents';

const StyledBox = styled(Box)({
  fontSize: 12,
  maxWidth: 600,
});

export const SoftwareLicensesModalContent = () => {
  const { closeModal } = useModalContext();
  const { t } = useI18n();

  return (
    <Modal data-testid="software-licenses-modal">
      <Modal.Header title="shared:software_license" />
      <Modal.Content>
        <StyledBox>
          <SoftwareLicense />
        </StyledBox>
      </Modal.Content>
      <Modal.Controls>
        <Button
          onClick={() => closeModal()}
          color="secondary"
          variant="contained"
        >
          {t('shared:cancel')}
        </Button>
      </Modal.Controls>
    </Modal>
  );
};
